import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import Tasks from '../../../../dashboards/Default/tables/Tasks';
import LogicalCheckAlert from '../../LogicalCheckAlert';

interface TasksTabProps {
  contract: IContract;
}

const TasksTab: React.FC<TasksTabProps> = ({ contract }) => {
  return (
    <Box>
      <Card sx={{ width: '100%', display: 'flex' }}>
        <CardContent
          sx={{
            color: 'inherit',
            width: '100%',
          }}
        >
          {contract.tasks
            ?.filter((t) => t.logicalCheck)
            .map((t, index) => {
              if (t.logicalCheck) {
                return (
                  <LogicalCheckAlert
                    key={index}
                    logicalCheck={t.logicalCheck}
                  />
                );
              }
              return null;
            })}

          <Tasks contract={contract} defaultRowsPerPage={10} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default TasksTab;
